export default {
    'Filtros de búsqueda': 'Search filters',
    'Equipo 1': 'Team 1',
    'Equipo 2': 'Team 2',
    'Competición': 'Competition',
    'Temporada': 'Season',
    'Buscar': 'Search',
    'Borrar': 'Clear',
    'Filtrar resultados': 'Filter results',
    'Resultados': 'Results',
    'Realizar Pedido': 'Perform Order',
    'Cancelar': 'Cancel',
    'Enviar': 'Send',
    'Enviar mensaje': 'Send message',
    'Pedido enviado correctamente!': 'Submit sent successfully!',
    'Ha ocurrido un error': 'An error occured',
    'Nombre': 'Name',
    'Nombre competo': 'Complete name',
    'Confirmar pedido': 'Confirm order',
    'Finalizar pedido': 'Finish order',
    'Mensaje adicional': 'Additional message',
    'E-mail': 'E-mail',
    'Observaciones': 'Observations',
    'Partidos seleccionados': 'Selected matches',
    'Pedido': 'Request',
    'El campo es obligatorio': 'The field is required',
    'El correo debe ser válido': 'The mail must be valid.',
    'Buscador': 'Search',
    'Precios y formas de envío': 'Prices and terms',
    'Más partidos': 'More matches',
    'Resúmenes': 'Summaries',
    'Contacto': 'Contact',
    'Contacta con nosotros': 'Contact us',
    'Métodos de pago aceptados': 'Accepted payment methods',
    'Ofertas especiales': 'Special offers',
    '5€ por partido': '5€ per match',
    'Descarga digital': 'Digital download',
    'Precios por partido': 'Prices for match',
    'Enviado correctamente!': 'Sent succesfully!',
    'Oferta': 'Offer',
    '100 partidos por': '100 matches for',
    'Transferencia': 'Transfer',
    'Mensaje': 'Message',
    'Muchas gracias.': 'Thank you.',
    'Página no encontrada': 'Page not found',
    'Forma de envío': 'Shipment type',
    'Método de pago': 'Payment form',
    'Descarga por link': 'Download by link',
    'Servidor FTP': 'FTP Server',
    'Descargar': 'Download',
    'Cuenta de Paypal': 'Paypal Account',
    'Cuenta de Bizum': 'Bizum Account',
    'Cargando': 'Loading...',
    'Serás redirigido a Stripe para completar el pago con tarjeta': 'You will be redirected to Stripe to complete the card payment',
    'Error al obtener la URL de Stripe': 'Error obtaining Stripe URL',
    'Error con Stripe:': 'Error with Stripe:',
    'Solicitar cuenta de Bizum por email': 'Request Bizum account by email',
};
